(function(){'use strict';var STOREFRONT_TOKEN='7fad72fcbf356bf1370aaa6bb446b9d8';var API_VERSION='2024-01';var STOREFRONT_URL=window.location.origin+'/api/'+API_VERSION+'/graphql.json';var LOOK_REF_LIMIT=3;var OUTFIT_REF_LIMIT=6;var VARIANT_SCAN_LIMIT=15;var STAGE2_SCAN_LIMIT=15;

var QUERY_STAGE1='query CompleteYourLook($ids:[ID!]!){nodes(ids:$ids){... on Product{id metafield(namespace:"custom",key:"carema_looks"){references(first:'+LOOK_REF_LIMIT+'){nodes{... on Metaobject{id active:field(key:"active"){value} main_product:field(key:"main_product"){reference{... on Product{id handle title availableForSale featuredImage{url} priceRange{minVariantPrice{amount currencyCode}} variants(first:'+VARIANT_SCAN_LIMIT+'){nodes{id availableForSale selectedOptions{name value}}}}}} outfit_products:field(key:"outfit_products"){references(first:'+OUTFIT_REF_LIMIT+'){nodes{... on Product{id handle title availableForSale featuredImage{url} priceRange{minVariantPrice{amount currencyCode}} variants(first:'+VARIANT_SCAN_LIMIT+'){nodes{id availableForSale selectedOptions{name value}}}}}}}}}}}}}}';

var QUERY_STAGE2='query Stage2BestSelling($first:Int!){collection(handle:"new-arrivals"){products(first:$first,sortKey:BEST_SELLING){nodes{id handle title availableForSale featuredImage{url} priceRange{minVariantPrice{amount currencyCode}} variants(first:'+VARIANT_SCAN_LIMIT+'){nodes{id availableForSale selectedOptions{name value}}}}}}}';

function toGid(numericId){return 'gid://shopify/Product/'+numericId;}
function fromGid(gid){var parts=(gid||'').split('/');return parts[parts.length-1];}
function fieldValue(field){return field?field.value:null;}
function formatMoney(amount){var n=parseFloat(amount);if(isNaN(n))return '';return '$'+n.toFixed(2).replace(/\.00$/,'');}
function twoWords(title){var parts=(title||'').trim().split(/\s+/);return parts.slice(0,2).join(' ');}

var STYLE_ID='cro-cyl-style';
function ensureStyle(){
  if(document.getElementById(STYLE_ID))return;
  var style=document.createElement('style');
  style.id=STYLE_ID;
  style.textContent='.cart-complete-look__row{display:flex;align-items:center;gap:10px;}'+
    '.cart-complete-look__row .cart-complete-look__card{flex:1;min-width:0;}'+
    '.cart-complete-look__add{flex:0 0 auto;width:32px;height:32px;border-radius:50%;border:1px solid #8E5E38;background:#fff;color:#8E5E38;font-size:18px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;}'+
    '.cart-complete-look__add:hover{background:#8E5E38;color:#fff;}'+
    '.cart-complete-look__add[aria-disabled="true"]{opacity:0.5;pointer-events:none;}'+
    '.cart-complete-look__selector{padding-top:10px;}'+
    '.cart-complete-look__selector-close{float:right;background:none;border:none;color:#80756d;font-size:16px;cursor:pointer;padding:0 0 0 8px;line-height:1;}'+
    '.cart-complete-look__group{margin-top:8px;}'+
    '.cart-complete-look__group-label{font-size:9px;letter-spacing:1.5px;text-transform:uppercase;color:#80756d;margin-bottom:6px;}'+
    '.cart-complete-look__pills{display:flex;flex-wrap:wrap;gap:6px;}'+
    '.cart-complete-look__pill{border:1px solid #d8cfc7;background:#fff;color:#2a2623;font-size:11px;padding:6px 10px;cursor:pointer;font-family:inherit;}'+
    '.cart-complete-look__pill.is-selected{background:#2a2623;color:#fff;border-color:#2a2623;}'+
    '.cart-complete-look__pill[disabled]{color:#c4baaf;text-decoration:line-through;cursor:not-allowed;background:#f5f1ec;}';
  document.head.appendChild(style);
}

class CompleteYourLook extends HTMLElement {
  connectedCallback(){
    this._lastKey=null;
    this._seq=0;
    ensureStyle();
  }

  init(){
    var idsAttr=(this.getAttribute('data-product-ids')||'').trim();
    if(!idsAttr){
      this._lastKey=null;
      this.innerHTML='';
      return;
    }
    var ids=idsAttr.split(',').filter(Boolean);
    var key=ids.slice().sort().join(',');
    if(key===this._lastKey){
      return;
    }
    var mySeq=++this._seq;
    var gids=ids.map(toGid);

    fetch(STOREFRONT_URL,{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':STOREFRONT_TOKEN},
      body:JSON.stringify({query:QUERY_STAGE1,variables:{ids:gids}})
    })
      .then(function(r){return r.json();})
      .then(function(data){
        if(mySeq!==this._seq)return;
        this._lastKey=key;
        if(data&&data.errors){console.warn('Complete Your Look GraphQL error',data.errors);}
        this._handleStage1Response(data,ids,mySeq);
      }.bind(this))
      .catch(function(err){
        if(mySeq!==this._seq)return;
        console.warn('Complete Your Look fetch error',err);
        this.innerHTML='';
      }.bind(this));
  }

  _addVariant(variantId,onFail){
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:variantId,quantity:1})
    })
      .then(function(r){return r.json().then(function(json){return {ok:r.ok,json:json};});})
      .then(function(result){
        if(!result.ok){
          if(onFail)onFail();
          return;
        }
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      })
      .catch(function(){
        if(onFail)onFail();
      });
  }

  // Shared Universal "+" UI — used identically by Stage 1 (Complete Your Look) and Stage 2 (Keep Shopping).
  // No second selector/add architecture: this is the only implementation, reused as-is.
  _renderCard(product,label){
    this.innerHTML='';
    var availableVariants=(product.variants&&product.variants.nodes||[]).filter(function(vv){return vv&&vv.availableForSale===true;});

    var imgUrl=product.featuredImage?product.featuredImage.url:'';
    var price=product.priceRange&&product.priceRange.minVariantPrice?formatMoney(product.priceRange.minVariantPrice.amount):'';
    var url='/products/'+product.handle;
    var displayTitle=twoWords(product.title).replace(/</g,'&lt;');
    var fullTitleAttr=product.title.replace(/"/g,'&quot;');

    var wrap=document.createElement('div');
    wrap.className='cart-complete-look';

    var showAdd=availableVariants.length>0;
    var addBtnHtml=showAdd
      ? '<button type="button" class="cart-complete-look__add" aria-label="Add '+fullTitleAttr+' to cart">+</button>'
      : '';
    wrap.innerHTML='<p class="cart-complete-look__label">'+label+'</p>'+
      '<div class="cart-complete-look__row">'+
      '<a href="'+url+'" class="cart-complete-look__card" aria-label="'+fullTitleAttr+'">'+
      (imgUrl?'<img src="'+imgUrl+'" alt="'+fullTitleAttr+'" width="56" loading="lazy">':'')+
      '<span class="cart-complete-look__info">'+
      '<span class="cart-complete-look__title">'+displayTitle+'</span>'+
      '<span class="cart-complete-look__price">'+price+'</span>'+
      '</span></a>'+
      addBtnHtml+
      '</div>';
    this.appendChild(wrap);

    if(!showAdd)return;

    var selectorHolder=document.createElement('div');
    wrap.appendChild(selectorHolder);

    var addBtn=wrap.querySelector('.cart-complete-look__add');
    var self=this;

    function disableAdd(){addBtn.setAttribute('aria-disabled','true');}
    function restoreAdd(){addBtn.removeAttribute('aria-disabled');}

    function directAdd(variantId){
      disableAdd();
      self._addVariant(fromGid(variantId),restoreAdd);
    }

    if(availableVariants.length===1){
      addBtn.addEventListener('click',function(evt){
        evt.preventDefault();
        if(addBtn.getAttribute('aria-disabled')==='true')return;
        directAdd(availableVariants[0].id);
      });
      return;
    }

    var optionNames=[];
    (availableVariants[0].selectedOptions||[]).forEach(function(o){optionNames.push(o.name);});

    function filteredBy(selections){
      return availableVariants.filter(function(v){
        return optionNames.every(function(name){
          if(!(name in selections))return true;
          var opt=(v.selectedOptions||[]).filter(function(o){return o.name===name;})[0];
          return opt&&opt.value===selections[name];
        });
      });
    }

    var selections={};
    optionNames.forEach(function(name){
      var values={};
      availableVariants.forEach(function(v){
        var opt=(v.selectedOptions||[]).filter(function(o){return o.name===name;})[0];
        if(opt)values[opt.value]=true;
      });
      var uniqueValues=Object.keys(values);
      if(uniqueValues.length===1){selections[name]=uniqueValues[0];}
    });

    var groupsToRender=optionNames.filter(function(name){return !(name in selections);});

    var expanded=false;

    function renderSelector(){
      var html='<div class="cart-complete-look__selector">'+
        '<button type="button" class="cart-complete-look__selector-close" aria-label="Close">&times;</button>';
      groupsToRender.forEach(function(name){
        var others=Object.assign({},selections);
        delete others[name];
        var candidates=filteredBy(others);
        var valuesSeen={};
        var orderedValues=[];
        candidates.forEach(function(v){
          var opt=(v.selectedOptions||[]).filter(function(o){return o.name===name;})[0];
          if(opt&&!valuesSeen[opt.value]){valuesSeen[opt.value]=true;orderedValues.push(opt.value);}
        });
        html+='<div class="cart-complete-look__group" data-option-name="'+name.replace(/"/g,'&quot;')+'">'+
          '<div class="cart-complete-look__group-label">'+name.replace(/</g,'&lt;')+'</div>'+
          '<div class="cart-complete-look__pills">';
        orderedValues.forEach(function(val){
          var isSelected=selections[name]===val;
          html+='<button type="button" class="cart-complete-look__pill'+(isSelected?' is-selected':'')+'" data-value="'+val.replace(/"/g,'&quot;')+'">'+val.replace(/</g,'&lt;')+'</button>';
        });
        html+='</div></div>';
      });
      html+='</div>';
      selectorHolder.innerHTML=html;

      selectorHolder.querySelector('.cart-complete-look__selector-close').addEventListener('click',function(evt){
        evt.preventDefault();
        collapse();
      });

      groupsToRender.forEach(function(name){
        var groupEl=selectorHolder.querySelector('[data-option-name="'+name.replace(/"/g,'\\"')+'"]');
        if(!groupEl)return;
        groupEl.querySelectorAll('.cart-complete-look__pill').forEach(function(pillEl){
          pillEl.addEventListener('click',function(){
            selections[name]=pillEl.dataset.value;
            var resolved=filteredBy(selections);
            var allChosen=groupsToRender.every(function(n){return n in selections;});
            if(allChosen&&resolved.length===1){
              directAdd(resolved[0].id);
              return;
            }
            renderSelector();
          });
        });
      });
    }

    function collapse(){
      expanded=false;
      selectorHolder.innerHTML='';
    }

    addBtn.addEventListener('click',function(evt){
      evt.preventDefault();
      if(addBtn.getAttribute('aria-disabled')==='true')return;
      if(expanded){collapse();return;}
      expanded=true;
      renderSelector();
    });
  }

  _handleStage1Response(data,cartProductIds,mySeq){
    this.innerHTML='';
    if(!data||!data.data||!data.data.nodes){return;}
    var nodes=data.data.nodes.filter(Boolean);
    var cartIdSet={};
    cartProductIds.forEach(function(id){cartIdSet[id]=true;});

    var seenLookIds={};
    var eligibleLooks=[];
    nodes.forEach(function(node){
      if(!node||!node.metafield||!node.metafield.references)return;
      node.metafield.references.nodes.forEach(function(look){
        if(!look||seenLookIds[look.id])return;
        var active=fieldValue(look.active)==='true';
        var mainProduct=look.main_product&&look.main_product.reference;
        if(!active||!mainProduct||mainProduct.availableForSale!==true)return;
        seenLookIds[look.id]=true;
        var outfitProducts=(look.outfit_products&&look.outfit_products.references&&look.outfit_products.references.nodes)||[];
        eligibleLooks.push({id:look.id,mainProduct:mainProduct,outfitProducts:outfitProducts});
      });
    });

    if(eligibleLooks.length===0)return; // no valid Carema Look at all — Stage 2 never triggers

    var best=null,bestCount=0,bestHeroInCart=false;
    eligibleLooks.forEach(function(look){
      var count=0,heroInCart=false;
      var lookProductIds={};
      lookProductIds[fromGid(look.mainProduct.id)]=true;
      look.outfitProducts.forEach(function(p){if(p)lookProductIds[fromGid(p.id)]=true;});
      Object.keys(lookProductIds).forEach(function(pid){if(cartIdSet[pid])count++;});
      heroInCart=!!cartIdSet[fromGid(look.mainProduct.id)];

      var take=false;
      if(count>bestCount){take=true;}
      else if(count===bestCount&&heroInCart&&!bestHeroInCart){take=true;}
      if(take){best=look;bestCount=count;bestHeroInCart=heroInCart;}
    });

    if(!best)return; // no eligible Look resolved — Stage 2 never triggers

    var recommend=null;
    var heroId=fromGid(best.mainProduct.id);
    if(best.mainProduct.availableForSale===true&&!cartIdSet[heroId]){
      recommend=best.mainProduct;
    }
    if(!recommend){
      for(var i=0;i<best.outfitProducts.length;i++){
        var candidate=best.outfitProducts[i];
        if(!candidate)continue;
        if(candidate.availableForSale!==true)continue;
        if(cartIdSet[fromGid(candidate.id)])continue;
        recommend=candidate;
        break;
      }
    }

    if(recommend){
      this._renderCard(recommend,'Complete Your Look');
      return;
    }

    // CRO-6.30 — LOOK_EXHAUSTED: a valid Carema Look exists (best !== null) but every piece is
    // already in the cart (recommend === null). This is the ONLY condition that triggers Stage 2.
    this._fetchStage2(cartIdSet,mySeq);
  }

  _fetchStage2(cartIdSet,mySeq){
    fetch(STOREFRONT_URL,{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':STOREFRONT_TOKEN},
      body:JSON.stringify({query:QUERY_STAGE2,variables:{first:STAGE2_SCAN_LIMIT}})
    })
      .then(function(r){return r.json();})
      .then(function(data){
        if(mySeq!==this._seq)return; // cart changed again while Stage 2 was in flight — discard
        if(data&&data.errors){console.warn('Keep Shopping GraphQL error',data.errors);return;}
        if(!data||!data.data||!data.data.collection||!data.data.collection.products){return;}
        var products=data.data.collection.products.nodes||[];
        var pick=null;
        for(var i=0;i<products.length;i++){
          var p=products[i];
          if(!p)continue;
          if(p.availableForSale!==true)continue;
          if(cartIdSet[fromGid(p.id)])continue;
          var hasAvailableVariant=(p.variants&&p.variants.nodes||[]).some(function(vv){return vv&&vv.availableForSale===true;});
          if(!hasAvailableVariant)continue;
          pick=p;
          break;
        }
        if(!pick)return; // fails silently — never affects cart/checkout
        this._renderCard(pick,'Keep Shopping');
      }.bind(this))
      .catch(function(err){
        if(mySeq!==this._seq)return;
        console.warn('Keep Shopping fetch error',err);
      });
  }
}

window.customElements.define('cc-complete-your-look', CompleteYourLook);
})();
